/*
Author: Liubo
Date: 2018-09-05
Desc: 框架配置文件
*/
const conf = {
    name: "JTUP framework",
    sysname: "新沃",
    systemtype: "2", // 0:柜台, 2:网上交易, 3:传真, 4:手机, 5: 微信
    api: {
        // axios AJAX 请求时的路径前缀
        baseUrl: process.env.NODE_ENV === "production" ? "/agate/api/v1" : "/api/v1",
        // 银行页面链接地址配置
        bankUrl: "/agate/jfit"
    },
    session_mode: "1", // 1:agate模式，通过token和key控制会话; 2:传统JROS模式, 前端不做特殊处理，由浏览器session 机制和服务端来控制会话
    encKey: "testkey", // 加密因子。仅用于session_mode 为2的情况。如果session_mode 为1，会取服务端返回的会话信息中的key作为加密因子
    encIV: "0102020303040506", // 加密向量
    projectType: "1", // 项目类型0直销，1代销
    const: {
        TTY_CHANLEID: "6000", // 天天盈网点号
        CARD_DATE_MAX: "99991231", // 证件号有效期最大值
        BIRTH_DATE: "19000101", // 出生日期最小值
        PAGE_SIZE: "10", // 分页数
        ZX_CENTER: "1000" // 直销中心渠道号
    },
    defaultEmailSuffix:"@qq.com,@163.com,@gmail.com,@sohu.com",//ump没有配置，取默认邮箱后缀
    cache: [
        {
            code: "_session",
            api: "/common/session",
            method: "GET",
            load: true
        },
        {
            code: "_dict",
            api: "/common/dictionary",
            method: "GET",
            load: true
        },
        {
            code: "_params",
            api: "/common/params",
            method: "GET",
            params: {terminaltype: "1"},
            load: true
        },
        {
            code: "_advertise",
            api: "/common/advertinfo",
            method: "GET",
            load: true
        },
        {
            code: "_notice",
            api: "/common/warmnotice",
            method: "GET",
            load: true
        },
        {
            code: "_user",
            api: "/acct/cust/profile",
            method: "GET"
        }

    ]
};
export default conf;
